











































































import Vue from 'vue';
import {
  genDownloadImageUrlByImage,
  sizes,
} from '@/modules/image';

import {
  publicBuyer,
  PublicBuyer,
  publicBuyerCompany,
  PublicBuyerCompany,
  publicExhibitor,
  PublicExhibitor,
  PublicExhibitorCompany,
  publicExhibitorCompany,
  publicBrand,
  PublicBrand,
  firebase,
  calender,
} from 'mostra';

import contact, { Contact } from '@/modules/contact/contact';
import { FirestoreDate } from '@/modules/firestore';
import message, { SnapShot, MessageTypes, Message } from '@/modules/contact/message';

interface DisplayMessage {
  date: FirestoreDate;
  messages: Message[];
}

interface DataType {
  brandLogoSrc: string | null;
  brandImageSrc: string | null;
  exhibitorCID: string | null;
  exhibitorUID: string | null;
  buyerCID: string | null;
  buyerUID: string | null;
  contactID: string | null;
  brandID: string | null;
  avatarExhibitor: string | null;
  avatarBuyer: string | null;
  brand: PublicBrand | null;
  buyer: PublicBuyer | null;
  contact: Contact | null;
  exhibitor: PublicExhibitor | null;
  companyBuyer: PublicBuyerCompany | null;
  companyExhibitor: PublicExhibitorCompany | null;
  messages: Message[];
  displayMessages: null | DisplayMessage[];
  loading: boolean;
  snapshot: any;
}

export default Vue.extend({
  name: 'buyer-contact-chat',
  data(): DataType {
    return {
      brandLogoSrc: null,
      brandImageSrc: null,
      exhibitorCID: null,
      exhibitorUID: '',
      buyerCID: null,
      buyerUID: '',
      brandID: '',
      contactID: '',
      avatarExhibitor: null,
      avatarBuyer: null,
      brand: null,
      buyer: null,
      exhibitor: null,
      contact: null,
      companyBuyer: null,
      companyExhibitor: null,
      messages: [],
      displayMessages: null,
      loading: false,
      snapshot: new SnapShot(),
    };
  },
  computed: {
    brandUrl(): string {
      if (!this.brandID) return '';
      const prefix = '/ssr/br/';
      return `${prefix}${this.brandID}`;
    },
    messageTypes() {
      return MessageTypes;
    },
  },
  methods: {
    async setSnapshot() {
      if (!this.contactID || !this.buyerCID || !this.exhibitorCID) {
        throw new Error('data is null:4');
      }
      this.snapshot.snapshot(
        this.contactID,
        this.buyerCID,
        this.exhibitorCID,
        await this.snapShotCallback,
        (err: Error) => {
          this.$fatal(err);
        },
      );
    },
    async snapShotCallback(val: Message[]) {
      const isMessageDelete = this.messages.length > val.length;
      this.messages = val;
      this.groupMessagesByDate(this.messages);
      await this.updateContact();
      if (isMessageDelete) return;
      this.scrollToBottom();
    },
    groupMessagesByDate(messages: Message[]) {
      // MEMO 送信日毎にmessagesをまとめる。
      const groupedMessages = messages.reduce<any[]>((result, val, i) => {
        if (i === 0) {
          const initialVal = {
            date: val.data.registeredDate,
            messages: [val],
          };
          return [...result, initialVal];
        }
        const lastMessage = messages[i - 1];
        const currentMessageDate = calender.formatDateJP2(val.data.registeredDate);
        const lastMessageDate = calender.formatDateJP2(lastMessage.data.registeredDate);
        if (currentMessageDate === lastMessageDate) {
          result[result.length - 1].messages.push(val);
          return [...result];
        }
        const newVal = {
          date: val.data.registeredDate,
          messages: [val],
        };
        return [...result, newVal];
      }, []);
      this.displayMessages = groupedMessages;
    },
    async setIds() {
      if (!(this.contact && this.contact.data)) return;
      this.exhibitorCID = this.contact.data.exhibitor;
      this.buyerCID = this.contact.data.buyer;
      this.brandID = this.contact.data.brandId;

      if (!this.buyerCID || !this.exhibitorCID || !this.brandID) return;

      const resCompanyBuyer = await publicBuyerCompany.load(this.buyerCID);
      if (!resCompanyBuyer) return;
      this.companyBuyer = resCompanyBuyer;
      this.buyerUID = resCompanyBuyer.data.owner;

      const resBrand = await publicBrand.load(this.brandID);
      if (!resBrand) return;
      this.brand = resBrand;
      this.exhibitorUID = resBrand.data.base.staff;

      const resCompanyExhibitor = await publicExhibitorCompany.load(
        this.exhibitorCID,
      );
      if (!resCompanyExhibitor) return;
      this.companyExhibitor = resCompanyExhibitor;
    },
    async fetchBuyer() {
      if (!this.buyerUID) throw Error('buyerUID is null');
      const res = await publicBuyer.load(this.buyerUID);
      this.buyer = res;
    },
    async fetchExhibitor() {
      if (!this.exhibitorUID) throw Error('exhibitorUID is null');
      const res = await publicExhibitor.load(this.exhibitorUID);
      this.exhibitor = res;
    },
    async fetchContact() {
      this.contactID = this.$route.params.id;
      const res = await contact.load(this.contactID);
      this.contact = res;
      console.log('contact', res);
    },
    async fetchAvatarExhibitor() {
      if (
        !this.exhibitor
      ) throw Error('cant get exhibitor');

      this.avatarExhibitor = await genDownloadImageUrlByImage(
        sizes.x512,
        this.exhibitor.data.profileImage,
      );
    },
    async fetchAvatarBuyer() {
      if (
        !this.buyer
      ) throw Error('cant get buyer');
      this.avatarBuyer = await genDownloadImageUrlByImage(
        sizes.x512,
        this.buyer.data.profileImage,
      );
    },
    async fetchBrandImages() {
      if (
        !this.brand
      ) throw Error('cant get brand');

      this.brandLogoSrc = await genDownloadImageUrlByImage(
        sizes.x512,
        this.brand.data.base.logo,
      );

      this.brandImageSrc = await genDownloadImageUrlByImage(
        sizes.x512,
        this.brand.data.base.image,
      );
    },
    onClickListButton() {
      this.$router.push({ name: 'buyer-contact-list' });
    },
    async sendMessage(val: {
      text: string;
      withVideoUrl: boolean;
      docs: any[];
    }) {
      try {
        this.$loading(true);
        if (!this.exhibitorCID) throw Error('exhibitorCID is null');
        if (!this.buyerCID) throw Error('buyerCID is null');
        if (!this.exhibitorUID) throw Error('exhibitorUID is null');
        if (!this.contactID) throw Error('contactID is null');
        if (!this.contact) throw Error('contact is null');

        const newMessage = message.createNewMessage(
          this.exhibitorCID,
          this.buyerCID,
        );

        newMessage.data.text = val.text;
        newMessage.data.withVideoUrl = val.withVideoUrl;
        newMessage.data.docs = val.docs;
        newMessage.data.type = MessageTypes.buyer;

        const res = await message.save(
          this.exhibitorUID,
          this.contactID,
          this.buyerCID,
          newMessage,
        );
        if (!res) throw Error('cant save message by buyer');

        this.contact.data.asReads = [];
        this.contact.data.latestSendDt = firebase.now();
        await this.updateContact();
        this.scrollToBottom();
      } catch (err: any) {
        this.$fatal(err);
      } finally {
        this.$loading(false);
      }
    },
    async onDeleteMessage(target: Message) {
      if (!this.exhibitorCID || !this.exhibitorUID || !this.contactID) return;
      target.data.deleter = this.exhibitorUID;
      target.data.isActivate = false;
      try {
        const res = await message.save(
          this.exhibitorUID,
          this.contactID,
          this.exhibitorCID,
          target,
        );
        if (!res) return;
        this.messages = this.messages.map((val: Message) => {
          if (val.id === target.id) return res;
          return val;
        });
      } catch (err: any) {
        this.$fatal(err);
      }
    },
    setAsReadDateTime() {
      if (!this.contact) return;
      const { asReadDateTimes = [] } = this.contact.data;
      const uid = this.$auth.uid;
      const isInAsReadDateTimes = asReadDateTimes.find(
        (val) => val.uid === uid,
      );
      const dt = Date.now();
      let newAsReadDateTimes;
      if (!isInAsReadDateTimes) {
        const newAsReadDateTime = { uid, dt };
        newAsReadDateTimes = [...asReadDateTimes, newAsReadDateTime];
      } else {
        newAsReadDateTimes = asReadDateTimes.map((val) => {
          if (val.uid === uid) return { uid, dt };
          return val;
        });
      }
      this.contact.data.asReadDateTimes = newAsReadDateTimes;
    },
    setAsRead() {
      if (!this.contact) return;
      const { asReads = [] } = this.contact.data;
      const uid = this.$auth.uid;
      const isInAsReads = asReads.includes(uid);
      if (!isInAsReads) asReads.push(uid);
      this.contact.data.asReads = asReads;
    },
    async updateContact() {
      if (!this.contact) return;
      this.setAsRead();
      this.setAsReadDateTime();
      const uid = this.$auth.uid;
      try {
        const res = await contact.save(uid, this.contact);
        if (!res) return;
        this.contact = res;
      } catch (err: any) {
        this.$fatal(err);
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const messageArea: any = this.$refs.messages;
        const messageAreaHeight = messageArea.scrollHeight;
        messageArea.scrollTop = messageAreaHeight;
      });
    },
    async fetchData() {
      await this.fetchContact();
      await this.setIds();
      await this.fetchBrandImages();
      await this.fetchBuyer();
      await this.fetchExhibitor();
      await this.fetchAvatarExhibitor();
      await this.fetchAvatarBuyer();
      await this.setSnapshot();
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    try {
      this.$loading(true);
      this.loading = true;
      await this.fetchData();
    } catch (err: any) {
      this.$fatal(err);
    } finally {
      this.loading = false;
      this.$loading(false);
    }
  },
  async mounted() {
    try {
      this.$loading(true);
      this.loading = true;
      await this.fetchData();
    } catch (err: any) {
      this.$fatal(err);
    } finally {
      this.loading = false;
      this.$loading(false);
    }
  },
  destroyed() {
    this.snapshot.detach();
  },
});
